import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { MainNavigations } from "../MainNavigations";
import { useSelector } from "react-redux";
import BusyLoader from "../skeletons/BusyLoader";
import Footer from "../components/Footer";
import useSEO from "../hooks/useSEO";
import { Paths } from "../constants/Paths";

export default function RootLayout({ userDetail }) {
  const { busyCallers } = useSelector((state) => state.common);
  const { setSEO } = useSEO();
  const location = useLocation();

  useEffect(() => {
    // Default SEO handling for static routes
    const path = location.pathname;
    let title = "Yatra Tickets";
    let desc = "Book cheap flights and tour packages with Yatra Tickets.";

    switch (path) {
      case Paths.BLANK:
      case Paths.HOME:
        title = "Cheap Flights from Kathmandu | Top Deals on International Flights | Yatra Tickets";
        desc = "Find cheap flights from Kathmandu to top destinations worldwide. Book now and save on international flights with exclusive deals and offers.";
        break;
      case Paths.ABOUT_US:
        title = "About Us | Yatra Tickets";
        break;
      case Paths.CONTACT_US:
        title = "Contact Us | Yatra Tickets";
        break;
      case Paths.FAQ:
        title = "Frequently Asked Questions | Yatra Tickets";
        break;
      case Paths.TERMS_AND_CONDITIONS:
        title = "Terms & Conditions | Yatra Tickets";
        break;
      case Paths.PRIVACY_POLICY:
        title = "Privacy Policy | Yatra Tickets";
        break;
      case Paths.GENERAL_RULES:
        title = "General Rules | Yatra Tickets";
        break;
      case Paths.MY_BOOKINGS:
        title = "My Bookings | Yatra Tickets";
        break;
      default:
        // For dynamic routes (details, booking, search etc.), component will handle SEO
        return;
    }

    setSEO(title, desc);
  }, [location.pathname, setSEO]);

  return (
    <div className="root-layout min-h-screen flex flex-col">
      {busyCallers && busyCallers.length > 0 && <BusyLoader />}
      {MainNavigations(userDetail)}
      <main className="flex-1 bg-gray-100 dark:bg-background">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
